module.exports = __webpack_public_path__ + "static/media/af.076c6007.svg";